// extracted by mini-css-extract-plugin
module.exports = {"desktop":"KpiTableFacts_desktop__rD2TT","mobile":"KpiTableFacts_mobile__3h1a4","status":"KpiTableFacts_status__2m_48","info":"KpiTableFacts_info__KR4PE"};